<template>
  <div class="page-view">
    <div class="header-row">
      <div>
        <h2>IP 黑名单</h2>
        <p>管理禁止登录的 IP，支持手动拉黑和解除。</p>
      </div>
      <el-button type="primary" @click="openCreate">新增 IP</el-button>
    </div>

    <div class="brand-card filter-card">
      <div class="toolbar-row">
        <el-input v-model="filters.keyword" placeholder="IP / 备注" clearable />
        <el-button type="primary" plain @click="handleQuery">查询</el-button>
      </div>
    </div>

    <div class="brand-card table-card">
      <el-table :data="items" stripe>
        <el-table-column prop="ip" label="IP" min-width="180" />
        <el-table-column prop="remark" label="备注" min-width="280" />
        <el-table-column prop="created_by_name" label="操作人" min-width="120" />
        <el-table-column prop="created_at" label="创建时间" min-width="180" />
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="{ row }">
            <el-button size="mini" type="danger" plain @click="removeItem(row)">解除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager-row">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes"
          :total="total"
          :page-size="pager.page_size"
          :current-page="pager.page"
          :page-sizes="[10, 20, 50]"
          @current-change="onPageChange"
          @size-change="onSizeChange"
        />
      </div>
    </div>

    <el-dialog title="新增黑名单 IP" :visible.sync="showDialog" width="520px">
      <el-form :model="form" label-width="90px">
        <el-form-item label="IP">
          <el-input v-model.trim="form.ip" placeholder="请输入 IP" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model.trim="form.remark" type="textarea" :rows="3" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" @click="submitForm">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { createIpBlacklist, deleteIpBlacklist, fetchIpBlacklist } from "../api/orders";

export default {
  data() {
    return {
      filters: { keyword: "" },
      items: [],
      total: 0,
      pager: { page: 1, page_size: 10 },
      showDialog: false,
      form: { ip: "", remark: "" },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const { data } = await fetchIpBlacklist({
        keyword: this.filters.keyword || undefined,
        page: this.pager.page,
        page_size: this.pager.page_size,
      });
      this.items = data.items || [];
      this.total = data.total || 0;
    },
    handleQuery() {
      this.pager.page = 1;
      this.loadData();
    },
    onPageChange(page) {
      this.pager.page = page;
      this.loadData();
    },
    onSizeChange(size) {
      this.pager.page = 1;
      this.pager.page_size = size;
      this.loadData();
    },
    openCreate() {
      this.form = { ip: "", remark: "" };
      this.showDialog = true;
    },
    async submitForm() {
      if (!this.form.ip) {
        this.$message.warning("请输入 IP");
        return;
      }
      await createIpBlacklist(this.form);
      this.showDialog = false;
      this.$message.success("新增成功");
      this.loadData();
    },
    async removeItem(row) {
      await this.$confirm(`确认解除黑名单 IP ${row.ip} 吗？`, "提示", { type: "warning" });
      await deleteIpBlacklist(row.id);
      this.$message.success("解除成功");
      this.loadData();
    },
  },
};
</script>

<style scoped>
</style>
